import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { applyAppearance, readStoredTheme, resolveAppearance } from './lib/theme';

// The inline script in index.html has normally done this already; repeating it
// here keeps the theme correct if that script was skipped or the document was
// served without it.
applyAppearance(resolveAppearance(readStoredTheme()));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
